import { observer } from 'mobx-react';
import React from 'react';
import { Section } from 'controls/react/layout/section';
import { WidgetProps } from 'controls/designer/features/widgets/widgetProps';
import { useStore } from 'core/react/useStore';
import { TextWidgetConfig } from './types';
import { TextWidgetStore } from './textWidgetStore';
import { DefaultWidgetWrapper } from 'controls/designer/features/widgets/defaultWidgetWrapper';

export const TextWidget = observer((props: WidgetProps<TextWidgetConfig>) => {
	const store = useStore(() => new TextWidgetStore(props.config));

	return (
		<DefaultWidgetWrapper {...props} showHeader={props.config.hideHeader ? false : undefined}>
			<Section appearance={'none'} onClick={() => props.navigator.go({})}>
				<div
					dangerouslySetInnerHTML={{ __html: store.renderedContent }}
					onMouseOver={(e) => {
						const target = e.target as HTMLElement;
						if (target.hasAttribute?.('data-id')) {
							void store.setTooltipForSpan(target);
						}
					}}
				/>
			</Section>
		</DefaultWidgetWrapper>
	);
});
